import { Tooltip, TooltipContent, TooltipTrigger } from "web-design-system";

const TRUNCATE_TOOLTIP_MIN_LEN = 16;

export function TruncatedNameWithTooltip({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  if (text.length < TRUNCATE_TOOLTIP_MIN_LEN) {
    return <span className={className}>{text}</span>;
  }

  return (
    <Tooltip delayDuration={300}>
      <TooltipTrigger asChild>
        <span className={className}>{text}</span>
      </TooltipTrigger>
      <TooltipContent portal>{text}</TooltipContent>
    </Tooltip>
  );
}
